import { Type } from 'class-transformer';
import { Collection } from './collection';

export class CollectionState {
  /**
    * Indicator if we are currently working on collection state.
    */
  isUpdating?: boolean;

  /**
    * List of collections.
    */
  @Type(() => Collection)
  listOfCollections: Collection[] = [];

  /**
    * The current collection is the collection we are currently working on.
    * This might need to changed in the future when we support more than one collection.
    */
  defaultCollectionId?: string;

  /**
    * Error message.
    */
  errorMessage?: string;
}
